import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Droppable } from '../../../components/DndKit';

import './CmcPlaceholder.css';

import { buildClass } from '../../../libs/classes';
import { ItemTypes } from '../../../utils/items';
import SampleTileDraggable from '../../../components/SamplesList/SampleTile/SampleTileDraggable';

const CmcPlaceholder = ({ dummies, droppableId }) => {
	useEffect(() => {
		console.log('init CmcPlaceholder "' + droppableId + '"', dummies);
	}, [droppableId, dummies]);

	return (
		<div className="cmc-placeholder">
			<Droppable droppableId={droppableId} isDropDisabled={false} type="TILE">
				{(provided, snapshot) => (
					<div
						className={buildClass('cmc-droppable').add(snapshot.isDraggingOver, 'dragged-over')}
						ref={provided.innerRef}
						{...provided.droppableProps}
					>
						{Object.keys(dummies).map((key, index) => (
							<SampleTileDraggable
								activeSampleId={0}
								cutoffPrice={0}
								index={index}
								key={key}
								sample={dummies[key]}
								type={ItemTypes.DUMMY}
								updSampleId={0}
								onClick={() => {}}
							/>
						))}
						<div>{provided.placeholder}</div>
					</div>
				)}
			</Droppable>
		</div>
	);
};

CmcPlaceholder.propTypes = {
	// Added dummies
	dummies: PropTypes.array.isRequired,
	// Droppable id
	droppableId: PropTypes.string.isRequired,
};

export default CmcPlaceholder;
